import React from "react";
import { isFn } from "../../utils/is-what";
import { DATA_SELECTABLE_ITEM_ID } from "../../constants";
import { useSelectableChatBoxListState } from "../SelectableChatBoxList";

export interface SelectableItemProps {
	selectKey: string | (() => string);
	children:
		| React.ReactElement<any>
		| ((props: { attrs: Record<string, any>; isSelected: boolean }) => React.ReactElement<any>);
}

export const SelectableItem = (props: SelectableItemProps) => {
	const selectKey: string = isFn(props.selectKey) ? props.selectKey() : props.selectKey;
	const { selectedItemsMap } = useSelectableChatBoxListState();
	const isSelected = selectedItemsMap[selectKey]
		? selectedItemsMap[selectKey] === selectKey
		: false;
	const attrs = {
		[DATA_SELECTABLE_ITEM_ID]: selectKey,
	};

	if (isFn(props.children)) {
		return props.children({ attrs, isSelected });
	} else {
		return React.cloneElement(props.children, {
			attrs,
			isSelected,
		});
	}
};
